import cx from "classnames";
import React, { useMemo } from "react";

import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import {
  HERO_BRAND_ID_CONTAINER,
  HERO_BRAND_MOBILE_ID_CONTAINER,
  HERO_ID_CONTAINER
} from "../../../../../constants";
import { useBusinessWidgetBackgroundImages } from "../../hooks";

const styles = ({ palette, breakpoints }: Theme) =>
  createStyles({
    childrenContainer: {
      minHeight: "inherit",
      position: "relative",
      zIndex: 2
    },
    inBackground: {
      zIndex: 1
    },
    markBackground: {
      backgroundColor: "transparent",
      backgroundPosition: "98% 95%",
      backgroundRepeat: "no-repeat",
      height: "100%",
      position: "absolute",
      width: "100%",
      [breakpoints.down("md")]: {
        display: "none"
      }
    },
    markBackgroundSm: {
      backgroundColor: "transparent",
      backgroundPosition: "98% 95%",
      backgroundRepeat: "no-repeat",
      height: "100%",
      position: "absolute",
      width: "100%",
      [breakpoints.up("md")]: {
        display: "none"
      }
    },
    root: {
      backgroundPosition: "100%",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      borderBottomLeftRadius: "100% 30px",
      borderBottomRightRadius: "100% 30px",
      color: palette.common.white,
      height: "100%",
      minHeight: "inherit",
      overflow: "hidden",
      position: "relative",
      width: "100%"
    }
  });

export interface BaseHeroProps {
  className?: string;
  backgroundColor?: string;
  backgroundUrl?: string;
  backgroundUrlSm?: string;
}

interface ContainerProps extends WithStyles<typeof styles>, BaseHeroProps {}

const makeURLProperty = (url: string) => `url(${url})`;

const ContainerBase: React.FC<ContainerProps> = ({
  classes,
  children,
  className,
  backgroundColor,
  backgroundUrl
}) => {
  const inlineStyles = useMemo(
    () => ({
      backgroundColor: backgroundColor || "transparent",
      backgroundImage: (backgroundUrl && makeURLProperty(backgroundUrl)) || "none"
    }),
    [backgroundColor, backgroundUrl]
  );
  const {
    backgroundUrl: backgroundLogo,
    backgroundUrlSm: backgroundLogoSm
  } = useBusinessWidgetBackgroundImages();
  const stampStyle = useMemo(
    () => ({
      desktop: {
        backgroundImage: backgroundLogo && makeURLProperty(backgroundLogo)
      },
      mobile: {
        backgroundImage: backgroundLogoSm && makeURLProperty(backgroundLogoSm)
      }
    }),
    [backgroundLogo, backgroundLogoSm]
  );

  return (
    <div style={inlineStyles} className={cx(classes.root, className)} data-id={HERO_ID_CONTAINER}>
      <div
        className={cx(classes.markBackground, classes.inBackground)}
        style={stampStyle.desktop}
        data-id={HERO_BRAND_ID_CONTAINER}
      />
      <div
        className={cx(classes.markBackgroundSm, classes.inBackground)}
        style={stampStyle.mobile}
        data-id={HERO_BRAND_MOBILE_ID_CONTAINER}
      />
      <div className={classes.childrenContainer}>{children}</div>
    </div>
  );
};

export const Container = withStyles(styles)(ContainerBase);
